"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalRegionByCoordinates = exports.getLocalRegion = exports.getLocalRegionWithCache = exports.getLocalAirportCodeByCoordinates = exports.getLocalAirportCode = void 0;
const airportCodeToRegion_1 = require("./airportCodeToRegion");
const fetchAirportCodeFromCdn_1 = require("./fetchAirportCodeFromCdn");
const utils_1 = require("@streamr/utils");
const haversine_1 = __importDefault(require("haversine"));
const DEFAULT_MAX_CACHE_AGE = 1000 * 60 * 60; // 1 hour
const logger = new utils_1.Logger(module);
let cachedLocalRegion = undefined;
let cachedLocalRegionFetchTime = undefined;
const getLocalAirportCode = async () => {
    let airportCode;
    try {
        airportCode = await (0, fetchAirportCodeFromCdn_1.fetchAirportCodeFromCdn)();
    }
    catch {
        return undefined;
    }
    return airportCode;
};
exports.getLocalAirportCode = getLocalAirportCode;
const getLocalAirportCodeByCoordinates = (latitude, longitude) => {
    const distances = [];
    Object.keys(airportCodeToRegion_1.airportCodeToRegion).forEach((key) => {
        const airport = airportCodeToRegion_1.airportCodeToRegion[key];
        const distance = (0, haversine_1.default)({ latitude, longitude }, { latitude: airport[1], longitude: airport[2] });
        distances.push([key, distance]);
    });
    // find the closest region
    distances.sort((a, b) => a[1] - b[1]);
    return distances[0][0];
};
exports.getLocalAirportCodeByCoordinates = getLocalAirportCodeByCoordinates;
const getRandomRegion = () => {
    // randomize the region form airpotCodeToRegionNumber
    const airportCodes = Object.keys(airportCodeToRegion_1.airportCodeToRegion);
    const randomAirportCode = airportCodes[Math.floor(Math.random() * airportCodes.length)];
    // indicate that the region is random by adding 99, the convention is
    // that random region numbers end with 99
    const randomRegion = airportCodeToRegion_1.airportCodeToRegion[randomAirportCode][0] + 99;
    logger.warn(`Could not get airport code, using random region: ${randomRegion}`);
    return randomRegion;
};
const getLocalRegionWithCache = async (maxCacheAge = DEFAULT_MAX_CACHE_AGE) => {
    if (cachedLocalRegion === undefined
        || cachedLocalRegionFetchTime === undefined
        || Date.now() - cachedLocalRegionFetchTime > maxCacheAge) {
        const region = await (0, exports.getLocalRegion)();
        // eslint-disable-next-line require-atomic-updates
        cachedLocalRegion = region;
        // eslint-disable-next-line require-atomic-updates
        cachedLocalRegionFetchTime = Date.now();
        return region;
    }
    return cachedLocalRegion;
};
exports.getLocalRegionWithCache = getLocalRegionWithCache;
const getLocalRegion = async () => {
    let airportCode = undefined;
    airportCode = await (0, exports.getLocalAirportCode)();
    if (airportCode === undefined || !airportCodeToRegion_1.airportCodeToRegion[airportCode]) {
        return getRandomRegion();
    }
    return airportCodeToRegion_1.airportCodeToRegion[airportCode][0];
};
exports.getLocalRegion = getLocalRegion;
const getLocalRegionByCoordinates = (latitude, longitude) => {
    const distances = [];
    Object.keys(airportCodeToRegion_1.airportCodeToRegion).forEach((key) => {
        const airport = airportCodeToRegion_1.airportCodeToRegion[key];
        const distance = (0, haversine_1.default)({ latitude, longitude }, { latitude: airport[1], longitude: airport[2] });
        distances.push([airport[0], distance]);
    });
    // find the closest region
    distances.sort((a, b) => a[1] - b[1]);
    return distances[0][0];
};
exports.getLocalRegionByCoordinates = getLocalRegionByCoordinates;
//# sourceMappingURL=getLocalRegion.js.map